import { VariaveisAmbiente } from "ambiente";
import { useApiBase } from "api/base";
import { useCallback } from "react";
import { useParams } from "react-router-dom";

export function useGetProdutoModificadores() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();
    const { empresaId } = useParams<any>()

    const getProdutoModificadores = useCallback(
        (modificadorId: string) => {
            return invocarApi({
                url: `api/v4/empresa/${empresaId}/modificadores/${modificadorId}`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'Domain': 'app.touchone.com.br',
                },
                enviarTokenUsuario: false,
                baseURL: VariaveisAmbiente.cardapioApi,
            });
        },
        [empresaId, invocarApi]
    );

    return {
        ...outrasPropriedades,
        getProdutoModificadores,
    };
}